import { Box, Checkbox, FormControlLabel, MenuItem, TextField } from "@mui/material";
import DateRangeInput from "features/dateRange/DateRangeInput";
import { OrderFilters } from "../ordersSlice";
import { Categories, Category } from "models/Checklist";
import CustomerSelect from "./CustomerSelect";
import ContactInput from "./ContactInput";
import SellerSelect from "./SellerSelect";
import { OrderStatus } from "models/Order";

type OrdersFiltersProps = {
  filters: OrderFilters;
  onChange: (filters: OrderFilters) => void;
};

const OrdersFilters: React.FC<OrdersFiltersProps> = (props) => {
  const { filters, onChange } = props;

  const {
    filterByOrderStatus,
    fromDate,
    toDate,
    filterByReferenceOrder,
    filterOnlyCustomerFollowUpNotDone,
    filterByHasReferenceContact,
    filterByReferenceContactName,
    filterByCompanyCode,
    filterByRoomCategory,
    filterBySellerSignature,
  } = filters;

  const updateFilters = (newFilters: Partial<OrderFilters>) => {
    onChange({
      ...filters,
      ...newFilters,
    });
  };

  return (
    <>
      <DateRangeInput
        startText="Skapad tidigast"
        endText="Skapad senast"
        value={[fromDate ? new Date(fromDate) : null, toDate ? new Date(toDate) : null]}
        onChange={([fromDate, toDate]) =>
          updateFilters({
            fromDate: fromDate ? fromDate.toISOString() : null,
            toDate: toDate ? toDate.toISOString() : null,
          })
        }
      />

      <TextField
        select
        fullWidth
        label="Orderstatus"
        variant="filled"
        value={filterByOrderStatus ?? ""}
        onChange={(e) =>
          updateFilters({ filterByOrderStatus: (e.target.value as OrderStatus) || null })
        }
      >
        <MenuItem value="" sx={{ color: "text.secondary" }}>
          Alla
        </MenuItem>
        <MenuItem value="PENDING">2</MenuItem>
        <MenuItem value="INCOMPLETE">X</MenuItem>
        <MenuItem value="COMPLETE">4</MenuItem>
      </TextField>

      <SellerSelect
        value={filterBySellerSignature}
        onChange={(value) => updateFilters({ filterBySellerSignature: value })}
      />

      <CustomerSelect
        value={filterByCompanyCode}
        onChange={(value) =>
          updateFilters({
            filterByCompanyCode: value.filterByCompanyCode || null,
          })
        }
      />

      <TextField
        select
        label="Rumskategori"
        variant="filled"
        value={filterByRoomCategory ?? ""}
        onChange={(e) =>
          updateFilters({ filterByRoomCategory: (e.target.value as Category) || null })
        }
      >
        <MenuItem value="" sx={{ color: "text.secondary" }}>
          Alla
        </MenuItem>
        {Object.entries(Categories).map(([key, category]) => (
          <MenuItem key={key} value={key}>
            {category}
          </MenuItem>
        ))}
      </TextField>

      <Box sx={{ display: "grid" }}>
        <FormControlLabel
          control={<Checkbox />}
          label="Endast referensobjekt"
          checked={!!filterByReferenceOrder}
          onChange={() => updateFilters({ filterByReferenceOrder: !filterByReferenceOrder })}
        />

        {!!filterByReferenceOrder && (
          <>
            <FormControlLabel
              control={<Checkbox />}
              label="Med kontaktperson"
              checked={!!filterByHasReferenceContact}
              onChange={() =>
                updateFilters({ filterByHasReferenceContact: !filterByHasReferenceContact })
              }
            />

            {!!filterByHasReferenceContact && (
              <ContactInput
                value={filterByReferenceContactName || ""}
                onChange={(value) => updateFilters({ filterByReferenceContactName: value || null })}
              />
            )}
          </>
        )}
      </Box>

      <FormControlLabel
        control={<Checkbox edge="start" />}
        label="Telemarketing ej utförd"
        checked={!!filterOnlyCustomerFollowUpNotDone}
        onChange={() =>
          updateFilters({ filterOnlyCustomerFollowUpNotDone: !filterOnlyCustomerFollowUpNotDone })
        }
      />
    </>
  );
};

export default OrdersFilters;
